import UserService from '@/services/user.service';
import axios from "axios";

export const ownerModule = {
    namespaced: true,
    state: {
        requests: [],
        owner: {},
        owners: new Map()
    },
    actions: {
        clearRequest({state}, name) {
            state.requests = state.requests.filter(obj => obj.requestName !== name);
        },
        makeOrCancelRequest({state}, name) {
            const requestExist = state.requests.find((item) => {
                return item.requestName === name ? item : null
            })

            if (requestExist)
                requestExist.cancel()

            const axiosSource = axios.CancelToken.source();

            state.requests = state.requests.filter(obj => obj.requestName !== name);
            state.requests.push({requestName: name, cancel: axiosSource.cancel});

            return axiosSource;
        },
        async createOwner({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "createOwner");
            data.role_id = '$owner'
            return UserService.createUser(axiosSource, data).then(
                async data => {
                    commit('insertOwner', data)
                    await dispatch('clearRequest', "createOwner");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async updateOwner({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "updateOwner");
            return UserService.updateUser(axiosSource, data).then(
                async data => {
                    commit('updateOwnerData', data)
                    await dispatch('clearRequest', "updateOwner");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async deleteOwner({commit, dispatch}, ownerId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "deleteOwner");
            return UserService.deleteUser(axiosSource, ownerId).then(
                async data => {
                    commit('removeOwnerFromList', ownerId)
                    await dispatch('clearRequest', "deleteOwner");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async getOwner({commit, dispatch}, ownerId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "getOwner");
            return UserService.getUser(axiosSource, ownerId).then(
                async data => {
                    commit('updateActiveOwner', data)
                    await dispatch('clearRequest', "getOwner");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        listOwners({commit}) {
            return UserService.listUsersByRole('$owner').then(
                data => {
                    commit('updateOwnersList', data);
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
    },
    mutations: {
        updateOwnersList(state, data) {
            state.owners = new Map()
            for (const entity of data) {
                entity.phone = entity.phone?.replace('+98', '0')
                state.owners.set(entity.id, entity)
            }
        },
        insertOwner(state, data) {
            state.owners.set(data.id, data)
        },
        updateOwnerData(state, data) {
            state.owners.set(data.id, data)
        },
        removeOwnerFromList(state, ownerId) {
            state.owners.delete(ownerId)
        },
        updateActiveOwner(state, data) {
            state.owner = data;
        }
    }
};